import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select, { components } from 'react-select';
import ReactMultiSelectCheckboxes from '../common/ReactMultiSelectCheckboxes';
import MasterService from '../../services/MasterService';
import { defaultZone, Zone, VIRTUAL_ADMIN, Business, Vertical, defaultVertical, Role, validationForFields, ADMIN_ROLES, TENANT, ECA_AGENT_TAGGING, TENANTS, LAP_BUSINESS_LINE_ID, PINJAM_BAGUS_BUSINESS_UNIT_ID, PINJAM_BAGUS_BUSINESSLINE, HRF_BUSINESS_VERTICAL_ID, FAVORITE_BUSINESS_UNIT_ID, DEBOUNCE_DELAY_IN_MS,PRIMA_BUSINESSLINE, PRIMA_BUSINESS_UNIT_ID,TOP_HIERARCHY_ROLE_ID, REM_VERTICAL_ID } from '../../config/constant';
import { toast } from 'react-toastify';
import Loader from '../common/loader';
import { useHasRight } from '../hooks/useHasRights'
import InsuranceBoxService from '../../services/InsuranceBoxService';
import { resetFieldsByName } from './helper';
import { isEmpty } from '../../config/helper';
import { debounce } from '../../utils';
import ReportingManagerMenuList from './ReportingManagerMenuList';
import Modal from '../common/Modal';
import secureStorage from '../../config/encrypt';
import ConfirmationModal from '../common/ConfirmationModal';

const { ValueContainer, Placeholder } = components;

const RoleDetails = (props) => {
    const { stateList, user_detail, updateBasicDetail, updateEcaAgent } = props;
    const [roleList, setRoleList] = useState([])
    const [CityData, setCityData] = useState(null);
    const [StateData, setStateData] = useState(null);
    const [reportingRoleList, setReportingRoleList] = useState([])
    const [reportingManagerList, setReportingManagerList] = useState([])
    const [reportingManagerHasNext, setReportingManagerHasNext] = useState(false);
    const [reportingManagerLoadingMore, setReportingManagerLoadingMore] = useState(false);
    const [reportingManagerCurrentPage, setReportingManagerCurrentPage] = useState(1);
    const [role_details, setRoleDetails] = useState({ zone_id: defaultZone, business_unit_id: TENANT !== TENANTS.FAV ? 1 : null, business_vertical_id: defaultVertical })
    const [role_change, setRoleChange] = useState(false)
    const [errors, SetErrors] = useState(props.location_state && props.location_state.tempErrors ? props.location_state.tempErrors : {});
    const [cityList, setCityList] = useState([])
    const [loading, setLoading] = useState(false);
    const [is_edit, setEdit] = useState(user_detail && user_detail.user_id && user_detail.user_id !== "" ? true : false)

    const [BusinessLine, SetBusinessLine] = useState([]);
    const [reporteeRoleChange, setReporteeRoleChange] = useState(false)
    const [role_validation_error_msg, setRoleValidationErrorMsg] = useState('');
    const [business_vertical_id, setBusinessVertialId] = useState(user_detail?.role_details?.business_vertical_id ?? defaultVertical);
    const [dropDownLoaders, setDropDownLoaders] = useState({ reporting_manager: false });
    const [reportingWarning, setReportingWarning] = useState({ show: false, pendingOption: null });
    const [confirmationData, setConfirmationData] = useState({ show: false, confirmationText: '', type: 'remap_involvement' });
    const [pendingProceed, setPendingProceed] = useState(null);
    const reportingManagerQueryRef = useRef({
        role_id: null,
        business_line: "",
        business_unit_id: null,
        business_vertical_id: null,
        search_text: "",
        page_limit: 500
    });
    const { adminRoleId } = useHasRight();
    const historyLead = useNavigate();

    const debouncedGetUsers = useRef(
        debounce((...args) => {
            getUsersByRole(...args);
    }, DEBOUNCE_DELAY_IN_MS)).current;

    useEffect(() => {
      return () => {
        debouncedGetUsers.cancel();
      };
    }, [debouncedGetUsers]);

    useEffect(() => {
        getRoleList(business_vertical_id)
        if (user_detail.role_details) {
            let role_details = user_detail.role_details
            role_details.zone_id = defaultZone
            setRoleDetails(role_details)
            getCityAndStateData(role_details, true)
            getBusinessLineList(role_details.role, business_vertical_id)
            getReportingRole(role_details)
            getUsersByRole(
                role_details.reporting_role,
                "reporting_role",
                role_details.business_line,
                role_details.business_unit_id,
                role_details.business_vertical_id,
                "",
                1,
                500,
                role_details.reporting_manager
            )
            if (user_detail.user_id) {
                setEdit(true)
            }
        } else {
            getBusinessLineList('', business_vertical_id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user_detail])

    useEffect(() => {
        if (role_details.role && role_details.business_line) {
            getReportingRole(role_details)
        }
        // eslint-disable-next-line
    }, [role_details.role, role_details.business_line])

    const disableBusinessUnit = () => is_edit && TENANTS.FAV === TENANT && business_vertical_id === HRF_BUSINESS_VERTICAL_ID && role_details.business_unit_id === FAVORITE_BUSINESS_UNIT_ID;
    const disableBusinessVertical = () => is_edit && !isEmpty(business_vertical_id) && [TENANTS.FAV, TENANTS.OTO].includes(TENANT) && business_vertical_id === HRF_BUSINESS_VERTICAL_ID;

    const isREMPresidentLocked = () =>
        is_edit && TENANT === TENANTS.PH && business_vertical_id === REM_VERTICAL_ID
        && user_detail?.role_details?.role === Role['President'];

    const getREMRoleOptions = () => {
        if (TENANT === TENANTS.PH && business_vertical_id === REM_VERTICAL_ID) {
            if (is_edit && [Role['Sales Manager'], Role['Sales Officer']].includes(user_detail?.role_details?.role)) {
                return roleList.filter(e => [Role['Sales Manager'], Role['Sales Officer']].includes(e.id));
            }
            return roleList.filter(e => [Role['President'], Role['Sales Manager'], Role['Sales Officer']].includes(e.id));
        }
        return roleList;
    };

    const filterPinjamBagusBusinessLine = (business_lines) => business_lines.filter(e => (PINJAM_BAGUS_BUSINESSLINE.includes(e.id)));
    const filterPrimaBusinessLine = (business_lines) => business_lines.filter(e => (PRIMA_BUSINESSLINE.includes(e.id)));
    const getBusinessLineList = async (role_id, business_vertical_id) => {
        MasterService.post('/sfa/user/business_line_list', { business_vertical_id })
            .then(function (response) {
                if (response.data.status === 200) {
                    let new_business_line = response.data.data.map(elm => ({ label: elm.business_line, value: elm.business_line_id, id: elm.business_line_id }));
                    if (role_id === Role.ARO && (TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV)) {
                        new_business_line = new_business_line.filter(e => e.id !== "UCF")
                    } else if (TENANT === TENANTS.OTO && role_id === Role["Alpha Agent"]) {
                        new_business_line = new_business_line.filter(e => (e.id === "UCRF" || e.id === "UBRF"));
                    } else if (TENANT === TENANTS.FAV && role_details.business_unit_id === PINJAM_BAGUS_BUSINESS_UNIT_ID) {
                        new_business_line = filterPinjamBagusBusinessLine()
                    }else if (TENANT === TENANTS.FAV && role_details.business_unit_id === PRIMA_BUSINESS_UNIT_ID) {
                        new_business_line = filterPrimaBusinessLine()
                    }
                    SetBusinessLine(new_business_line);
                }
            })
            .catch(function (response) {
            });
    }

    const getCityAndStateData = async (role_details, setData) => {
        await getCityList(role_details.state, setData, role_details)
        let state_data = stateList.filter(e => role_details.state.includes(e.id))
        if (state_data && state_data.length > 0) {
            setStateData(state_data)
        }
    }

    const getCityList = async (state_ids, setData, role_details) => {
        let temp_role_details = role_details
        if (state_ids.length === 0) {
            temp_role_details["city"] = []
            setCityData([])
            setCityList([])
        } else {
            await MasterService.post('/sfa/user/city_list', { state_ids })
                .then(function (response) {
                    if (response.data.status === 200) {
                        var city_list = response.data.data.map(elm => ({ id: elm.id, label: elm.city_name, value: elm.id, state_id: elm.state_id }));
                        setCityList(city_list);
                        if (setData) {
                            let city_data = city_list.filter(e => role_details.city.includes(e.id))
                            if (city_data && city_data.length > 0) {
                                let currval = city_data.map(v => v.id);
                                temp_role_details["city"] = currval
                                setCityData(city_data)
                            } else {
                                temp_role_details["city"] = []
                                setCityData([])
                            }
                        }
                    }
                })
                .catch(function (response) {
                });
        }
    }

    const getRoleList = async (business_vertical_id) => {
        MasterService.post('/sfa/user/role_list', { business_vertical_id })
            .then(function (response) {
                if (response.data.status === 200) {
                    let role_list = response.data.data.filter(e => e.name !== VIRTUAL_ADMIN)
                    role_list = role_list.map(elm => ({ id: elm.id, label: elm.name, value: elm.name }));
                    if (adminRoleId === ADMIN_ROLES['sales_support']) {
                        role_list = role_list.filter(item => item.id !== parseInt(Role['Agent']))
                    }
                    setRoleList(role_list)
                }
            })
            .catch(function (response) {
            });
    }
    const getUsersByRole = async (
        role_id,
        keyname,
        business_line,
        business_unit_id,
        business_vertical_id,
        search_text = "",
        page_no = 1,
        page_limit = 500,
        selected_manager_id = null
    ) => {
        if (!role_id) return;
        if (business_line !== LAP_BUSINESS_LINE_ID && !(TENANT === TENANTS.PH && business_vertical_id === REM_VERTICAL_ID)) business_line = "";
        const selectedUserId = selected_manager_id ?? role_details?.reporting_manager;
        const resolvedSearchText = (search_text && String(search_text).trim().length)
            ? search_text
            : (selectedUserId ? String(selectedUserId) : "");
        reportingManagerQueryRef.current = {
            role_id,
            business_line,
            business_unit_id,
            business_vertical_id,
            search_text: resolvedSearchText,
            page_limit
        };
        if (page_no > 1) {
            setReportingManagerLoadingMore(true);
        }
        setDropDownLoaders(prev => ({ ...prev, reporting_manager: true }));
        const getUsersPayload = { role_id, business_line, business_unit_id, vertical_id: business_vertical_id };
        if (TENANT !== TENANTS.PH) {
            getUsersPayload.search_text = resolvedSearchText;
            getUsersPayload.page_no = page_no;
            getUsersPayload.page_limit = page_limit;
        }
        MasterService.post('/sfa/user/get-users', getUsersPayload)
            .then(function (response) {
                business_line = business_line ? business_line : role_details.business_line
                if (response.data.status === 200) {
                    const responseData = response.data.data || {};
                    let reporting_manager_list = (responseData.user_list || []).map(elm => ({ id: parseInt(elm.id), label: elm.name, value: elm.name, business_line: elm.business_line, business_line_name: elm.business_line_name }));
                    reporting_manager_list = reporting_manager_list.filter(e => e.id !== parseInt(user_detail.user_id))
                    if (keyname === "reporting_role") {
                        reporting_manager_list = reporting_manager_list.map(item => {
                            return { ...item, label: item.business_line_name ? `${item.label} (${item.business_line_name})` : item.label }
                        })
                        if (page_no > 1) {
                            setReportingManagerList(prevList => {
                                const merged = [...prevList, ...reporting_manager_list];
                                const uniqueMap = new Map(merged.map(item => [item.id, item]));
                                return Array.from(uniqueMap.values());
                            })
                        } else {
                            setReportingManagerList(reporting_manager_list)
                        }
                        const hasNext = response.data.pagination.hasNext ?? false;
                        setReportingManagerHasNext(hasNext);
                        setReportingManagerCurrentPage(page_no);
                    }
                }
            })
            .catch(function (response) {
            })
            .finally(() => {
                if (page_no > 1) {
                    setReportingManagerLoadingMore(false);
                }
                setDropDownLoaders(prev => ({ ...prev, reporting_manager: false }));
            });
    }
    const getReportingRole = async (temp_role_detail) => {
        let business_line = temp_role_detail.business_line ? temp_role_detail.business_line : ""
        let role_id = temp_role_detail.role ? temp_role_detail.role : ""
        MasterService.post('/sfa/user/reporting_role_list', { role_id, vertical_id: temp_role_detail?.business_vertical_id ?? 1 })
            .then(function (response) {
                if (response.data.status === 200) {
                    let reporting_role_list = isEmpty(response.data.data) ? [] : response.data.data.map(elm => ({ id: elm.id, label: elm.name, value: elm.name }));
                    if (business_line === "UCF" && (TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV)) {
                        reporting_role_list = reporting_role_list.filter(e => e.id !== Role.ARO)
                    }
                    if (is_edit) {
                        let selected_reporting_role = reporting_role_list.filter(e => e.id === temp_role_detail.reporting_role)
                        if (selected_reporting_role.length === 0) {
                            temp_role_detail.reporting_role = ''
                            temp_role_detail.reporting_manager = ""
                            setRoleDetails(temp_role_detail)
                        }
                    }
                    
                    setReportingRoleList(reporting_role_list)
                }
            })
            .catch(function (error) {
                console.log('error = ', error);
            });
    }
    const CustomValueContainer = ({ children, ...props }) => {
        return (
            <ValueContainer {...props}>
                <Placeholder {...props} isFocused={props.isFocused}>
                    {props.selectProps.placeholder}
                </Placeholder>
                {React.Children.map(children, child =>
                    child && child.type !== Placeholder ? child : null
                )}
            </ValueContainer>
        );
    };

    const handleChangeMultiSel = (field_name, field_obj, event) => {

        let currval = [];
        var role_details_temp = { ...role_details };
        let selected_value = []
        if (event.action === "select-option" && event.option.value === "*") {
            selected_value = field_name === "state" ? [{ label: "Select All", value: "*" }, ...stateList] : [{ label: "Select All", value: "*" }, ...cityList]
            currval = field_name === "state" ? stateList.map(v => v.id) : cityList.map(v => v.id);
        } else if (event.action === "deselect-option" && event.option.value === "*") {
            selected_value = []
        } else if (event.action === "deselect-option" && event.option.value !== "*") {
            selected_value = field_obj.filter((o) => o.value !== "*")
            currval = selected_value.map(v => v.id)
        } else if (field_name === "state" && field_obj.length === stateList.length) {
            currval = stateList.map(v => v.id);
            selected_value = [{ label: "Select All", value: "*" }, ...stateList]
        } else if (field_name === "city" && field_obj.length === cityList.length) {
            currval = cityList.map(v => v.id);
            selected_value = [{ label: "Select All", value: "*" }, ...cityList]
        } else {
            currval = field_obj.map(v => v.id);
            selected_value = field_obj
        }
        role_details_temp[field_name] = currval;
        if (field_name === "state") {
            setStateData(selected_value);
            getCityList(currval, true, role_details_temp)
        }
        if (field_name === "city") {
            setCityData(selected_value);
        }
        setRoleDetails(role_details_temp);

        let tempErrors = { ...errors };
        if (field_obj.length) {
            tempErrors[field_name] = '';
        }
        SetErrors(tempErrors);
    }

    const handleChange = async (name, selectedOption) => {
        let temp_role_details = { ...role_details };
        let tempErrors = { ...errors };
        if (name === 'role') {
            props.getConfigList(selectedOption.id, role_details.business_vertical_id, role_details.business_line)
            temp_role_details['reporting_role'] = ""
            temp_role_details['reporting_manager'] = ""
            temp_role_details['business_line'] = ""
            temp_role_details[name] = selectedOption.id
            getBusinessLineList(selectedOption.id, business_vertical_id)
            setRoleChange(true)
            setReportingRoleList([])
        } else if (name === 'reporting_role') {
            // props.resetTagging()
            temp_role_details['reporting_manager'] = ""
            if (shouldShowReportingWarning(selectedOption.id)) {
                setReportingWarning({ show: true, pendingOption: selectedOption });
                return;
            }
            let tempConfigList = props.ConfigList;
            if (role_details.role === Role['Agent']) {
                if (selectedOption.id === Role['ARO']) {
                    tempConfigList.tagging_roles = tempConfigList?.tagging_roles?.filter(item => ![...ECA_AGENT_TAGGING, 'dsoo'].includes(item.value)) || [];
                    props.setConfigList(tempConfigList);
                } else if (selectedOption.id !== Role['BM']) {
                    tempConfigList.tagging_roles = tempConfigList?.tagging_roles?.filter(item => !ECA_AGENT_TAGGING.includes(item.value)) || [];
                    props.setConfigList(tempConfigList);
                } else {
                    props.getConfigList(role_details.role, role_details.business_vertical_id, role_details.business_line, selectedOption.id);
                }
            } else {
                props.getConfigList(role_details.role, role_details.business_vertical_id, role_details.business_line);
            }
            setReporteeRoleChange(true);
            getUsersByRole(selectedOption.id, name, temp_role_details['business_line'], temp_role_details['business_unit_id'], temp_role_details['business_vertical_id'], "", 1, 500, 0)
            temp_role_details[name] = selectedOption.id
        } else if (name === 'business_line') {
            temp_role_details = resetFieldsByName(name, temp_role_details);
            temp_role_details[name] = selectedOption.id
            temp_role_details['tagging_id'] = ''
            props.getConfigList(temp_role_details.role, temp_role_details.business_vertical_id, selectedOption.id)
            getReportingRole(temp_role_details)
        } else if (name === 'business_unit_id') {
            temp_role_details = resetFieldsByName(name, temp_role_details);
            temp_role_details[name] = selectedOption.id;
            setBusinessVertialId('')
        } else if (name === 'business_vertical_id') {
            temp_role_details['business_vertical_id'] = selectedOption.id
            if([TENANTS.FAV, TENANTS.OTO].includes(TENANT)){
                temp_role_details = resetFieldsByName(name, temp_role_details);
                getRoleList(selectedOption.id);
                getBusinessLineList(role_details.role, selectedOption.id)
            } else if (TENANT === TENANTS.PH) {
                temp_role_details = resetFieldsByName(name, temp_role_details);
                getBusinessLineList(role_details.role, selectedOption.id);
            }
            setBusinessVertialId(selectedOption.id);
            setRoleDetails(temp_role_details);
        } else {
            temp_role_details[name] = selectedOption.id
        }
        setRoleDetails(temp_role_details);
        if (selectedOption.id !== '') {
            tempErrors[name] = '';
        }
        SetErrors(tempErrors);
    };

    const handleManagerSearch = (name, inputValue, actionMeta) => {
        if(TENANT === TENANTS.PH) return inputValue
        if (name !== 'reporting_manager') return inputValue;
        if (actionMeta?.action !== 'input-change') return inputValue;

        const typedValue = String(inputValue || "");
        debouncedGetUsers(role_details?.reporting_role, "reporting_role", role_details?.business_line, role_details?.business_unit_id, role_details?.business_vertical_id, typedValue, 1,          500,        null );
        return typedValue;
    };

    const handleReportingManagerMenuScrollToBottom = () => {
        if (!reportingManagerHasNext || reportingManagerLoadingMore) return;
        const { role_id, business_line, business_unit_id, business_vertical_id, search_text, page_limit } = reportingManagerQueryRef.current;
        if (!role_id) return;
        getUsersByRole(
            role_id,
            "reporting_role",
            business_line,
            business_unit_id,
            business_vertical_id,
            search_text,
            reportingManagerCurrentPage + 1,
            page_limit,
            null
        );
    };

    

    const handleClickCancel = () => {
        if (user_detail?.user_id) {
            historyLead('/view-user/' + user_detail?.user_id_hash, { replace: true })
        }
    }

    const handleClickNext = async () => {
        if (isValidate()) {
            if (TENANT === TENANTS.PH) {
                setLoading(true)
                let ready_to_role_change = false
                let ready_to_role_change_reportee = false


                let role_validation_status = await role_change_validation();

                let user_logout = false
                if (role_details.role !== role_details.previous_role_id || role_details.reporting_manager !== role_details.previous_manager_id) {
                    user_logout = true
                }

                if (role_change && is_edit) {
                    await MasterService.post('/sfa/user/get_reportees', { userId: [user_detail.user_id] }).then(async function (response) {
                        if (response.data.status === 200) {
                            if (response.data.data.reportee && response.data.data.reportee.length) {
                                toast.error("Please remove the reportees")
                            } else {
                                ready_to_role_change_reportee = true
                            }
                        }
                    })
                    if (ready_to_role_change_reportee) {
                        ready_to_role_change = true
                    }

                    if (role_change) {
                        updateBasicDetail();
                    }

                    if (ready_to_role_change && !role_validation_status) {
                        handleClick(user_logout)
                    } else {
                        setRoleChange(false);
                    }
                } else {
                    handleClick(user_logout)
                }
                setLoading(false)
                return
            }
            
            let open_lead_and_reportee_data = user_detail && user_detail.open_lead_and_reportee_data ? user_detail.open_lead_and_reportee_data : {}
            if (is_edit && (role_details.business_line !== role_details.previous_business_line || (parseInt(role_details.role) !== parseInt(role_details.previous_role_id)) || (parseInt(role_details.reporting_manager) !== parseInt(role_details.previous_manager_id)) || role_details.business_unit_id !== role_details.previous_business_unit_id)) {
                setLoading(true)
                let params = {
                    user_id: user_detail.user_id,
                    role_id: role_details.previous_role_id
                }
                let ready_to_role_change = false
                let ready_to_role_change_lead = false
                let ready_to_role_change_reportee = false
                let ready_to_role_change_loan = false
                let ready_to_role_change_progression = false;
                
                let pending_loan_res
                let pending_lead_res
                
                let wallet_balance = 0
                let disbursal_in_past_three_months = 0
                let user_under_progression = open_lead_and_reportee_data && open_lead_and_reportee_data.progression_users ? open_lead_and_reportee_data.progression_users : []
                
                if (user_under_progression && user_under_progression.progression_user && user_under_progression.progression_mapping) {
                    if (user_under_progression.progression_user.length === 0 && user_under_progression.progression_mapping.length === 0) {
                        ready_to_role_change_progression = true;
                    } else {
                        // ready_to_role_change_progression = true
                        toast.error("Cannot update Role & Reporting as user is under journey flow")
                    }
                } else {
                    ready_to_role_change_progression = true;
                }
                
                let agent_role_id = (TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV || TENANT === TENANTS.PH) ? parseInt(Role.Agent) : parseInt(Role.FA)
                let bro_role_id = (TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV) ? parseInt(Role.BRO) : parseInt(Role.MO)
                if (!([agent_role_id, bro_role_id].includes(role_details.role) && [agent_role_id, bro_role_id].includes(role_details.previous_role_id)) || role_details.business_line !== role_details.previous_business_line || role_details.business_unit_id !== role_details.previous_business_unit_id) {
                    // if (parseInt(role_details.role) !== parseInt(VP_ID)) {
                        params.user_id = parseInt(params.user_id);
                        pending_loan_res = open_lead_and_reportee_data && open_lead_and_reportee_data.pendingRefinanceLeads ? open_lead_and_reportee_data.pendingRefinanceLeads : []
                        pending_lead_res = open_lead_and_reportee_data && open_lead_and_reportee_data.pendingLoanboxLeads ? open_lead_and_reportee_data.pendingLoanboxLeads : []
                        // }

                    if (role_details.business_line !== role_details.previous_business_line || (parseInt(role_details.role) !== parseInt(role_details.previous_role_id)) ||
                        parseInt(role_details.previous_reporting_role) !== parseInt(role_details.reporting_role) || role_details.business_unit_id !== role_details.previous_business_unit_id) {
                        if (open_lead_and_reportee_data && open_lead_and_reportee_data.allReporteeList) {
                            let primary_reportee = open_lead_and_reportee_data.allReporteeList.filter(e => !e.is_secondary)
                            //let secondary_reportee = open_lead_and_reportee_data.allReporteeList.filter(e=>e.is_secondary)
                            if (primary_reportee.length) {
                                toast.error("Please remove the primary reportees")
                            } else {
                                ready_to_role_change_reportee = true
                            }
                        } else {
                            ready_to_role_change_reportee = true
                        }
                    } else {
                        ready_to_role_change_reportee = true
                    }

                    // if (parseInt(role_details.role) !== parseInt(VP_ID)) {
                    let errArr = {
                        ucrf: [],
                        ubrf: [],
                        ucf: []
                    };
                    let errorLoan = false;
                    let errorLead = false;
                    let isCheckedLoan = false;
                    let isCheckedLead = false;    
                                                  
                    if (pending_loan_res && pending_loan_res.data && pending_loan_res.status === 200) {
                        isCheckedLoan = true;
                        for (const key of ['UCRF', 'UBRF']) {
                            if (pending_loan_res && pending_loan_res.data && pending_loan_res.data[key]) {
                                for (const item of pending_loan_res.data[key]) {                                   
                                    if (item.disbursal_in_past_three_months) {
                                        disbursal_in_past_three_months = 1                                        
                                    }
                                    for (const [k, v] of Object.entries(item['validation'])) {
                                        if (v === 1) {
                                            errorLoan = true;
                                            errArr[`${key.toLowerCase()}`].push(k);
                                        }
                                    }
                                }
                            }
                        }
                    }else if (TENANT === TENANTS.FAV && business_vertical_id === HRF_BUSINESS_VERTICAL_ID){
                        isCheckedLoan = true;
                    }                 
                    if (pending_lead_res && pending_lead_res.data && pending_lead_res.status === 200) {
                        isCheckedLead = true;
                        if (pending_lead_res && pending_lead_res.data && pending_lead_res.data) {
                            for (const item of pending_lead_res.data) {
                                for (const [k, v] of Object.entries(item['validation'])) {
                                    if (v === 1) {
                                        errorLead = true;
                                        errArr['ucf'].push(k);
                                    }
                                }
                            }
                        }
                    }
                    if (open_lead_and_reportee_data && open_lead_and_reportee_data.hasWalletAmount) {
                        wallet_balance = 1
                    }

                    if (errArr.ucrf.length !== 0 || errArr.ubrf.length !== 0 || errArr.ucf.length !== 0) {
                        for (const [k, v] of Object.entries(errArr)) {
                            if (v.length !== 0) {
                                toast.error(`Error: ${v.join(',')} in ${k.toUpperCase()}`)
                            }
                        }
                    }

                    if ((TENANT === TENANTS.OTO || TENANT === TENANTS.FAV || TENANT === TENANTS.EMP) && !errorLoan && isCheckedLoan) {
                        ready_to_role_change_loan = true;
                    } else if (TENANT === TENANTS.TRIV) {
                        ready_to_role_change_loan = true;
                    }

                    if (!errorLead && isCheckedLead) {
                        ready_to_role_change_lead = true;
                    }

                    if (TENANT === TENANTS.OTO || TENANT === TENANTS.TRIV) {
                        if (ready_to_role_change_lead && ready_to_role_change_loan && ready_to_role_change_reportee && ready_to_role_change_progression) {
                            ready_to_role_change = true
                        }
                    } else {
                        if (ready_to_role_change_loan && ready_to_role_change_reportee && ready_to_role_change_progression) {
                            ready_to_role_change = true
                        }
                    }
                    // } else {
                    //     if (ready_to_role_change_reportee) {
                    //         ready_to_role_change = true
                    //     }
                    // }
                    
                } else {
                    ready_to_role_change = true;
                }
                if (role_change) {
                    updateBasicDetail();
                }
                if (TENANT === TENANTS.FAV && (parseInt(role_details.role) !== parseInt(role_details.previous_role_id) || role_details.business_unit_id !== role_details.previous_business_unit_id)) {
                    if (wallet_balance && validationForFields.agent_wallet_view.includes(parseInt(params.role_id))) {
                        ready_to_role_change = false
                        toast.error("Please make sure the Wallet balance is Rp 0 !")
                    }
                }
                if (TENANT === TENANTS.FAV && role_details.business_unit_id !== role_details.previous_business_unit_id) {
                    if (disbursal_in_past_three_months) {
                        const proceed = window.confirm(`User(${user_detail.user_id}) has 90 days of disbursal. Do you want to proceed?`);
                        if (!proceed) {
                            ready_to_role_change = false
                        }
                    }
                }
                if (ready_to_role_change && ready_to_role_change_progression) {
                    handleClick(true)
                }
                setLoading(false)
            } else {
                handleClick(false)
            }
        }
    }

    // REM vertical on PH tenant uses a REST backend; other verticals use the loanbox GraphQL gateway.
    const isREMLoanRestFlow = () => TENANT === TENANTS.PH && business_vertical_id === REM_VERTICAL_ID;

    const buildLoanApprovedDocParams = (params) => {
        if (isREMLoanRestFlow()) {
            // REST payload (dummy) - plain params instead of a GraphQL query string.
            return {
                vertical_id: REM_VERTICAL_ID,
                api_called_by: 'sfa',
                user_id: params.user_id,
                role_id: params.role_id
            };
        }
        // Existing (non-REM) flow unchanged - same GraphQL payload as before.
        return {
            query: 'query{ get_is_all_approved_docs(api_called_by:sfa user_id : ' + params.user_id + ' role_id:' + params.role_id + ') { is_all_doc_approved lead_ids } }'
        };
    };

    const isLoanDocPending = (res) => {
        if (!(res && res.data && res.data.status === 200 && res.data.data)) return false;
        if (isREMLoanRestFlow()) {
            return res.data.data.open_application === true;
        }
        return !!(res.data.data.data && res.data.data.data.get_is_all_approved_docs
            && res.data.data.data.get_is_all_approved_docs.is_all_doc_approved === "false");
    };

    const role_change_validation = async () => {
        let current_role_id = 0;
        if (props.user_detail && props.user_detail.role_details && props.user_detail.role_details.role) {
            current_role_id = props.user_detail.role_details.role;
        }
        let params = {
            user_id: user_detail.user_id,
            role_id: role_details.previous_role_id
        }
        let role_status = {}
        role_status.insurance_open_application_status = false;
        role_status.loan_open_application_status = false;
        if (role_change && Number(current_role_id) === Role['Agent']) {
            let pending_in_loanbox = false;
            let pending_in_insurance = false;
            const loan_lead_params = buildLoanApprovedDocParams(params);

            const pending_loan_lead_res = await MasterService.post('/sfa/user/loan_approved_doc', loan_lead_params);
            if (isLoanDocPending(pending_loan_lead_res)) {
                role_status.insurance_open_application_status = true;
                pending_in_loanbox = true;
                // setRoleValidationErrorMsg('There are pending Application for User in loanbox.')
            }

            let insurance_open_application = await InsuranceBoxService.getUserPendingInsuranceApplication({ user_list: [params] });

            if (insurance_open_application && insurance_open_application.data && insurance_open_application.data.status === 200) {
                if (insurance_open_application && insurance_open_application.data && insurance_open_application.data.data) {
                    for (const item of insurance_open_application.data.data) {
                        // eslint-disable-next-line
                        for (const [k, v] of Object.entries(item['validation'])) {
                            if (v >= 1) {
                                role_status.insurance_open_application_status = true;
                                pending_in_insurance = true;
                                // setRoleValidationErrorMsg('There are pending Application for User in insurance.')
                            }
                        }
                    }
                }
            }
            if (pending_in_loanbox && pending_in_insurance) {
                setRoleValidationErrorMsg('There are pending Application for User in loanbox and insurance both.')
            } else if (pending_in_loanbox) {
                setRoleValidationErrorMsg('There are pending Application for User in loanbox.')
            } else if (pending_in_insurance) {
                setRoleValidationErrorMsg('There are pending Application for User in insurance.')
            }
            return role_status.insurance_open_application_status;
        }

        if (role_change && Number(current_role_id) === Role['Sales Officer']) {

            const loan_lead_params = buildLoanApprovedDocParams(params);

            const pending_loan_lead_res = await MasterService.post('/sfa/user/loan_approved_doc', loan_lead_params);
            if (isLoanDocPending(pending_loan_lead_res)) {
                role_status.loan_open_application_status = true;
                setRoleValidationErrorMsg('The Sales Officer needs to get all their pending tasks completed before their role can be updated.')
            }


            let insurance_open_application = await InsuranceBoxService.getUserPendingInsuranceApplication({ user_list: [params] });

            if (insurance_open_application && insurance_open_application.data && insurance_open_application.data.status === 200) {
                if (insurance_open_application && insurance_open_application.data && insurance_open_application.data.data) {
                    for (const item of insurance_open_application.data.data) {
                        // eslint-disable-next-line
                        for (const [k, v] of Object.entries(item['validation'])) {
                            if (v >= 1) {
                                role_status.loan_open_application_status = true;
                                setRoleValidationErrorMsg('The Sales Officer needs to get all their pending tasks completed before their role can be updated')
                            }
                        }
                    }
                }
            }
            return role_status.loan_open_application_status;

        }

        if (role_change && Number(current_role_id) === Role['Sales Manager'] && isREMLoanRestFlow()) {

            const loan_lead_params = buildLoanApprovedDocParams(params);

            const pending_loan_lead_res = await MasterService.post('/sfa/user/loan_approved_doc', loan_lead_params);
            if (isLoanDocPending(pending_loan_lead_res)) {
                role_status.loan_open_application_status = true;
                setRoleValidationErrorMsg('There are pending Application for User in loanbox.')
            }

            return role_status.loan_open_application_status;

        }


    }

    const shouldShowReportingWarning = (reportingRoleId) => {
        if (TENANT === TENANTS.OTO) {
            return role_details.role === Role['BM'] &&
                ['UCF', 'UCRF', 'UBRF'].includes(role_details.business_line) &&
                [Role['ZM'], Role['DZM']].includes(reportingRoleId);
        }
        if (TENANT === TENANTS.FAV) {
            return role_details.role === Role['MM'] &&
                ['UCF', 'UCRF'].includes(role_details.business_line) &&
                reportingRoleId === Role['RM'];
        }
        return false;
    };

    const getReportingWarningText = (reportingRoleName) => {
        const lang = secureStorage.getItem('lang');
        const roleName = TENANT === TENANTS.OTO ? 'BM' : 'MM';
        if (lang === 'id') {
            return `Reporting Line yang dipilih untuk ${roleName} adalah ${reportingRoleName}, yang menyimpang dari hierarki standar.\nPerubahan ini berpotensi memengaruhi perhitungan dan penerimaan insentif DSA/Fee, serta konfigurasi sistem terkait lainnya.`;
        }
        return `The Reporting Line selected for ${roleName} is ${reportingRoleName}, which deviates from the standard hierarchy.\nThis change has the potential to affect the calculation and receipt of DSA/Fee incentives, as well as other related system configurations.`;
    };

    const handleReportingWarningContinue = () => {
        const selectedOption = reportingWarning.pendingOption;
        setReportingWarning({ show: false, pendingOption: null });

        let temp_role_details = { ...role_details, reporting_manager: '' };
        let tempErrors = { ...errors };
        let tempConfigList = props.ConfigList;
        if (role_details.role === Role['Agent']) {
            if (selectedOption.id === Role['ARO']) {
                tempConfigList.tagging_roles = tempConfigList?.tagging_roles?.filter(item => ![...ECA_AGENT_TAGGING, 'dsoo'].includes(item.value)) || [];
                props.setConfigList(tempConfigList);
            } else if (selectedOption.id !== Role['BM']) {
                tempConfigList.tagging_roles = tempConfigList?.tagging_roles?.filter(item => !ECA_AGENT_TAGGING.includes(item.value)) || [];
                props.setConfigList(tempConfigList);
            } else {
                props.getConfigList(role_details.role, role_details.business_vertical_id, role_details.business_line, selectedOption.id);
            }
        } else {
            props.getConfigList(role_details.role, role_details.business_vertical_id, role_details.business_line);
        }
        setReporteeRoleChange(true);
        getUsersByRole(selectedOption.id, 'reporting_role', temp_role_details['business_line'], temp_role_details['business_unit_id'], temp_role_details['business_vertical_id'], "", 1, 500, 0);
        temp_role_details['reporting_role'] = selectedOption.id;
        setRoleDetails(temp_role_details);
        if (selectedOption.id !== '') {
            tempErrors['reporting_role'] = '';
        }
        SetErrors(tempErrors);
    };

    const proceedToNext = async (user_logout, role_details_override) => {
        // Use the snapshot captured when the confirmation was shown (if any), because a
        // role change triggers updateBasicDetail() -> setUserDetail, whose effect re-syncs
        // local role_details from props and would otherwise discard the user's changes.
        const role_details_to_save = role_details_override || role_details;
        if (is_edit) {
            await props.setUserLogout(user_logout)
        }

        if (TENANT !== TENANTS.PH && reporteeRoleChange) {
            updateEcaAgent({ reporting_role: role_details_to_save.reporting_role, role: role_details_to_save.role });
        }
        await props.handleSave(role_details_to_save, 'role_details', false)
        if (is_edit) {
            // historyLead('basic_details?id=' + user_detail.user_id);
            historyLead("/edit-user/basic_details?id=" + user_detail.user_id_hash);
        } else {
            // historyLead('basic_details');
            historyLead('/add-user/basic_details');
        }
    }

    const handleClick = async (user_logout) => {
        const role_changed = parseInt(role_details.role) !== parseInt(role_details.previous_role_id);
        const manager_changed = (parseInt(role_details.reporting_manager) !== parseInt(role_details.previous_manager_id)) || (parseInt(role_details.reporting_role) !== parseInt(role_details.previous_reporting_role));
        if (is_edit && user_detail && user_detail.user_id && (role_changed || manager_changed)) {
            try {
                setLoading(true)
                const response = await MasterService.post('/sfa/user/checkRemapInvolvement', { user_ids: [parseInt(user_detail.user_id)] });
                setLoading(false)
                if (response.data.status === 200 && response.data.data && response.data.data.involved) {
                    setPendingProceed({ user_logout, role_details: { ...role_details } });
                    setConfirmationData({
                        show: true,
                        type: 'remap_involvement',
                        confirmationText: 'This user is part of pending Remap Requests (as a user or as the Requested Primary Manager). Changing the reporting manager or role will remove the user from those Remap Requests. Do you want to continue?'
                    });
                    return;
                }
            } catch (err) {
                setLoading(false)
            }
        }
        await proceedToNext(user_logout);
    }

    const confirmationModalResponse = ({ response }) => {
        setConfirmationData({ show: false, confirmationText: '', type: 'remap_involvement' });
        const pending = pendingProceed;
        setPendingProceed(null);
        if (response && pending) {
            proceedToNext(pending.user_logout, pending.role_details);
        } else if (pending && pending.role_details) {
            // Cancelled: restore the user's in-progress selection (it may have been
            // reverted by the role-change re-sync effect while the popup was open)
            setRoleDetails(pending.role_details);
        }
    }

    const isValidate = () => {
        let tempRoleDetail = { ...role_details };
        let formIsValid = true;
        let tempErrors = {};

        if (!tempRoleDetail["business_unit_id"] && TENANT !== TENANTS.PH) {
            formIsValid = false;
            tempErrors["business_unit_id"] = 'Business unit is required';
        }
        if (!tempRoleDetail["business_vertical_id"]) {
            formIsValid = false;
            tempErrors["business_vertical_id"] = 'Business vertical is required';
        }
        if (!tempRoleDetail["state"] || !tempRoleDetail["state"].length) {
            formIsValid = false;
            tempErrors["state"] = 'State is required';
        }
        if (!tempRoleDetail["city"] || !tempRoleDetail["city"].length) {
            formIsValid = false;
            tempErrors["city"] = 'City is required';
        }
        if (!tempRoleDetail["business_line"]) {
            formIsValid = false;
            tempErrors["business_line"] = 'Business Line is required';
        }
        if (!tempRoleDetail["role"]) {
            formIsValid = false;
            tempErrors["role"] = 'Role is required';
        } else {
            if (TENANT !== TENANTS.FAV) {
                if (tempRoleDetail["role"] === Role.ARO && tempRoleDetail["business_line"] === "UCF") {
                    formIsValid = false;
                    tempErrors["business_line"] = 'Business Line Not Valid';
                }
            }
        }
        if (tempRoleDetail.role !== TOP_HIERARCHY_ROLE_ID && !tempRoleDetail["reporting_role"]) {
            formIsValid = false;
            tempErrors["reporting_role"] = 'Primary Reporting Role is required';
        }
        if (tempRoleDetail.role !== TOP_HIERARCHY_ROLE_ID && !tempRoleDetail["reporting_manager"]) {
            formIsValid = false;
            tempErrors["reporting_manager"] = 'Primary Reporting Manager is required';
        }
        // else {
        //     if (TENANT != TENANTS.FAV) {
        //         if (tempRoleDetail["business_line"]) {
        //             let selected_manager = reportingManagerList.filter(e => e.id == tempRoleDetail["reporting_manager"])
        //             if (selected_manager.length && selected_manager[0].business_line != tempRoleDetail["business_line"]) {
        //                 formIsValid = false;
        //                 tempErrors["reporting_manager"] = 'Primary Reporting Manager Not Valid';
        //             }
        //         }
        //     }
        // }

        // if (tempRoleDetail["secondary_reporting_manager"] && tempRoleDetail["business_line"]) {
        //     let selected_manager = secondaryReportingManagerList.filter(e=>e.id == tempRoleDetail["secondary_reporting_manager"])
        //     if(selected_manager.length && selected_manager[0].business_line == tempRoleDetail["business_line"]){
        //         formIsValid = false;
        //         tempErrors["secondary_reporting_manager"] = 'Secondary Reporting Manager Not Valid';
        //     }
        // }

        // if (validationForFields.secondary_reporting_div.includes(parseInt(role_details.role)) &&
        //     validationForFields.secondary_reporting_div_business_line.includes(role_details.business_line)) {
        //     if (!tempRoleDetail["secondary_reporting_role"]) {
        //         formIsValid = false;
        //         tempErrors["secondary_reporting_role"] = 'Secondary Reporting Role is required';
        //     }
        //     if (!tempRoleDetail["secondary_reporting_manager"]) {
        //         formIsValid = false;
        //         tempErrors["secondary_reporting_manager"] = 'Secondary Reporting Manager is required';
        //     }
        // }     
        SetErrors(tempErrors);
        return formIsValid;
    }

    const getBusinessLineOptions = () => {
        if (TENANT === TENANTS.FAV && role_details.business_unit_id === PINJAM_BAGUS_BUSINESS_UNIT_ID) {
            return filterPinjamBagusBusinessLine(BusinessLine)
        } else if (TENANT === TENANTS.FAV && role_details.business_unit_id === PRIMA_BUSINESS_UNIT_ID) {
            return filterPrimaBusinessLine(BusinessLine)
        }
        return BusinessLine;
    }
    const selectedBusiness = (TENANT !== TENANTS.FAV) ? Business.find(e => e.id === 1) : Business.find(e => e.id === role_details.business_unit_id);
    
    return (
        <div className='role-details-form p-xxl add-user-detail-filed'>
            {loading ? <Loader /> : null}
            {confirmationData.show ? <ConfirmationModal confirmationData={confirmationData} confirmationModalResponse={confirmationModalResponse} /> : null}
            <h2>Role Details</h2>
            <h3>
                Business Vertical

            </h3>
            <div className='row'>
                <fieldset className="single-select col-md-4">
                    <div className="material">
                        <Select
                            // isDisabled={(disableBusiness)}
                            components={{ ValueContainer: CustomValueContainer }}
                            options={Business}
                            placeholder="Business Unit"
                            className="react-select"
                            classNamePrefix="react-select"
                            onChange={handleChange.bind(this, 'business_unit_id')}
                            value={selectedBusiness}
                            isDisabled={disableBusinessUnit()}
                        />
                        {
                            (errors && errors.business_unit_id) ? <span className="error show">{errors.business_unit_id}</span> : ''
                        }
                    </div>
                </fieldset>
                <fieldset className="single-select col-md-4">
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            // components={{ IndicatorSeparator:() => null }}
                            options={Vertical.filter(e => e.business_unit_ids.includes(role_details.business_unit_id))}
                            placeholder="Vertical"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={Vertical.filter(e => e.id === business_vertical_id)}
                            onChange={handleChange.bind(this, 'business_vertical_id')}
                            isDisabled={disableBusinessVertical()}
                        />
                        {
                            (errors && errors.business_vertical_id) ? <span className="error show">{errors.business_vertical_id}</span> : ''
                        }
                    </div>
                </fieldset>
            </div>

            <h3>
                Map Region
            </h3>
            <div className='row'>
                <fieldset className="single-select col-md-4">
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            // components={{ IndicatorSeparator:() => null }}
                            options={Zone}
                            placeholder="Zone"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={Zone.filter(e => e.id === role_details.zone_id)}
                        />

                    </div>
                </fieldset>
                <fieldset className="multiselect-dropDown col-md-4">
                    <div className="material">

                        {/* <ReactMultiSelectCheckboxes
                                isMulti
                                options={[{ label: "Select All", value: "*" }, ...stateList]}
                                placeholderButtonLabel="State*"
                                iconAfter="false"
                                getDropdownButtonLabel={getDropdownButtonLabel}
                                value={StateData?.length === stateList?.length ? [{ label: "Select All", value: "*" }, ...stateList] : StateData}
                                onChange={handleChangeMultiSel.bind(this, "state")}
                                getOptionLabel={({ label }) => label}
                                getOptionValue={({ id }) => id}
                            /> */}
                        <ReactMultiSelectCheckboxes
                            options={[{ label: "Select All", value: "*" }, ...stateList]}
                            value={StateData?.length === stateList?.length ? [{ label: "Select All", value: "*" }, ...stateList] : StateData}
                            onChange={handleChangeMultiSel.bind(this, "state")}
                            name="state"
                            placeholder="State*"
                            isDisabled={false}
                            isClearable={true}
                            getOptionLabel={({ label }) => label}
                            getOptionValue={({ id }) => id}
                        />
                        {(StateData && StateData.length > 0) ? <label data-label="State*" className="form-label date-label"></label> : ''}
                        {
                            (errors && errors.state) ? <span className="error show">{errors.state}</span> : ''
                        }
                    </div>
                </fieldset>
                <fieldset className="multiselect-dropDown col-md-4">
                    <div className="material">
                        {/* <ReactMultiSelectCheckboxes
                                isMulti
                                options={[{ label: "Select All", value: "*" }, ...cityList]}
                                placeholderButtonLabel="City*"
                                iconAfter="false"
                                getDropdownButtonLabel={getDropdownButtonLabel}
                                value={cityList?.length > 0 && CityData?.length === cityList?.length ? [{ label: "Select All", value: "*" }, ...cityList] : CityData}
                                onChange={handleChangeMultiSel.bind(this, "city")}
                                getOptionLabel={({ label }) => label}
                                getOptionValue={({ id }) => id}
                            /> */}

                        <ReactMultiSelectCheckboxes
                            options={[{ label: "Select All", value: "*" }, ...cityList]}
                            value={cityList?.length > 0 && CityData?.length === cityList?.length ? [{ label: "Select All", value: "*" }, ...cityList] : CityData}
                            onChange={handleChangeMultiSel.bind(this, "city")}
                            name="city"
                            placeholder="City*"
                            isDisabled={StateData && StateData.length > 0 ? false : true}
                            isClearable={true}
                            getOptionLabel={({ label }) => label}
                            getOptionValue={({ id }) => id}
                        />
                        {(CityData && CityData.length > 0) ? <label data-label="City*" className="form-label date-label"></label> : ''}
                        {
                            (errors && errors.city) ? <span className="error show">{errors.city}</span> : ''
                        }
                    </div>
                </fieldset>
            </div>
            <h3>
                Role Details
            </h3>
            <div className='row'>
                <fieldset className="single-select col-md-4">
                    <div className="material">
                        <Select components={{ ValueContainer: CustomValueContainer }}
                            options={getREMRoleOptions()}
                            placeholder="Role*"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={roleList.filter(e => e.id === role_details.role)}
                            onChange={handleChange.bind(this, 'role')}
                            isDisabled={isREMPresidentLocked()}
                        />
                    </div>
                    {
                        (errors && errors.role) ? <span className="error show">{errors.role}</span> : ''
                    }
                    {
                        (role_validation_error_msg) ? <span className="error show absolute">{role_validation_error_msg}</span> : ''
                    }
                </fieldset>
                {BusinessLine && BusinessLine.length > 0 &&
                    <fieldset className="single-select col-md-4">
                        <div className="material">
                            <Select components={{ ValueContainer: CustomValueContainer }}
                                options={getBusinessLineOptions()}
                                value={getBusinessLineOptions().filter((e) => e.id === role_details.business_line)}
                                onChange={handleChange.bind(null, 'business_line')}
                                placeholder="Business Line*"
                                className="react-select"
                                classNamePrefix="react-select"
                                isDisabled={(is_edit && user_detail.role_details.business_line === LAP_BUSINESS_LINE_ID)}
                            />
                        </div>
                        {
                            (errors && errors.business_line) ? <span className="error show">{errors.business_line}</span> : ''
                        }
                    </fieldset>
                }
            </div>

            <h3>
                Reporting Details
            </h3>
            <div className='row'>
                <fieldset className="single-select col-md-4">
                    <div className="material">
                        <Select components={{ ValueContainer: CustomValueContainer }}
                            options={reportingRoleList}
                            placeholder={`Primary Reporting Role${role_details.role === TOP_HIERARCHY_ROLE_ID ? '' : '*'}`}
                            className="react-select"
                            classNamePrefix="react-select"
                            value={reportingRoleList.filter(e => e.id === role_details.reporting_role)}
                            isDisabled={role_details.role && role_details.role !== "" ? false : true}
                            onChange={handleChange.bind(this, 'reporting_role')}
                        />
                    </div>
                    {
                        (errors && errors.reporting_role) ? <span className="error show absolute">{errors.reporting_role}</span> : ''
                    }
                </fieldset>
                <fieldset className="single-select col-md-4">
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer, MenuList: ReportingManagerMenuList }}
                            options={reportingManagerList}
                            value={reportingManagerList.find(({ id }) => id === role_details.reporting_manager) || null}
                            getOptionLabel={({ label }) => label}
                            getOptionValue={({ id }) => id}
                            onChange={handleChange.bind(this, 'reporting_manager')}
                            onInputChange={handleManagerSearch.bind(this, 'reporting_manager')}
                            onMenuScrollToBottom={handleReportingManagerMenuScrollToBottom}
                            isSearchable={true}
                            placeholder={`Primary Reporting Manager${role_details.role === TOP_HIERARCHY_ROLE_ID ? '' : '*'}`}
                            className="react-select"
                            isDisabled={role_details.reporting_role && role_details.reporting_role !== "" ? false : true}
                            classNamePrefix="react-select"
                            isLoading={dropDownLoaders.reporting_manager}
                            loadingMessage={() => <span>Loading...</span>}
                            onLoadMore={handleReportingManagerMenuScrollToBottom}
                            isLoadingMore={reportingManagerLoadingMore} 
                        />
                    </div>
                    {
                        (errors && errors.reporting_manager) ? <span className="error show absolute">{errors.reporting_manager}</span> : ''
                    }
                </fieldset>

            </div>


            <div className='br-top-flex'>
                {is_edit ? <div className="t-right">
                    <button className='btn-line m-xs-l' onClick={handleClickCancel.bind(this)}>
                        Cancel
                    </button>
                </div> : null}
                <div className="t-right">
                    <button className='btn-primary' onClick={handleClickNext.bind(this)}>
                        Next
                    </button>



                </div>
            </div>

            {reportingWarning.show && (
                <div className="delete-incentive-popup model-popup-outer">
                    <Modal show={reportingWarning.show} handleClose={() => setReportingWarning({ show: false, pendingOption: null })}>
                        <div className="modal-header"></div>
                        <div className="modal-body">
                            <div className="delete-popup-txt">
                                <p style={{ whiteSpace: 'pre-line' }}>
                                    {getReportingWarningText(reportingWarning.pendingOption?.label)}
                                </p>
                                <div className="yes-no-btn">
                                    <button className="btn-line" onClick={() => setReportingWarning({ show: false, pendingOption: null })}>
                                        {secureStorage.getItem('lang') === 'id' ? 'Batalkan' : 'Cancel'}
                                    </button>
                                    <button className="btn-primary" onClick={handleReportingWarningContinue}>
                                        {secureStorage.getItem('lang') === 'id' ? 'Lanjutkan' : 'Continue'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            )}
        </div>
    )
}

export default RoleDetails;
